<app-split-pane
  storageKey="split.docs"
  [initialLeftRatio]="0.7"
  [collapseBreakpointPx]="1024"
  [collapsedOnSmallScreens]="true"
>
  <ng-container left>
    <app-split-pane-vertical storageKey="split.docs.left" [initialTopRatio]="0.7">
      <ng-container top>
        <app-chat [suggestions]="docsSuggestions" [context]="docsContext" placeholder="Ask or draft documentation..."></app-chat>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="docs.chat"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>

  <ng-container right>
    <app-split-pane-vertical storageKey="split.docs.right" [initialTopRatio]="0.7">
      <ng-container top>
        <div class="container">
          <div>Documentation viewer/editor will be displayed here</div>
          <div>We might show:</div>
          <ul>
            <li>Recently edited docs</li>
            <li>Documentation outline</li>
            <li>Selected document preview</li>
          </ul>
        </div>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="docs.main"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>
</app-split-pane>
